module.exports = __webpack_public_path__ + "img/seven6Blue.a67493ab.jpg";